import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_MEMBERSHIPTYPES_LOAD,
    ACTION_MEMBERSHIPTYPES_LOAD_BY_ID,

    ACTION_MEMBERSHIPTYPES_SAVE,

    ACTION_MEMBERSHIPTYPES_CREATE,

    ACTION_MEMBERSHIPTYPES_VALIDATE,

    IMembershipTypeLoadAction,
    IMembershipTypeLoadByIdAction,
    IMembershipTypeLoadFailureAction,
    IMembershipTypeLoadSuccessAction,

    IMembershipTypeSaveAction,
    IMembershipTypeSaveSuccessAction,
    IMembershipTypeSaveFailureAction,

    IMembershipTypeCreateAction,
    IMembershipTypeCreateSuccessAction,
    IMembershipTypeCreateFailureAction,

    IMembershipTypeValidateAction,
    IMembershipTypeValidateSuccessAction,
    IMembershipTypeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/membershipTypes";
import { membershiptypesApi } from "../services/membershipType";


export const
    getMembershipTypesEpic = (action$): Observable<IMembershipTypeLoadSuccessAction | IMembershipTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_MEMBERSHIPTYPES_LOAD)
            .mergeMap((_action: IMembershipTypeLoadAction) => {
                return membershiptypesApi
                    .getMembershipTypes()
                    .map(response =>
                        LoadSuccess(response.membershipTypes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMembershipTypeByIdEpic = (action$): Observable<IMembershipTypeLoadSuccessAction | IMembershipTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_MEMBERSHIPTYPES_LOAD_BY_ID)
            .mergeMap((action: IMembershipTypeLoadByIdAction) => {
                return membershiptypesApi
                    .getMembershipTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.membershipType, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setMembershipTypeEpic = (action$): Observable<IMembershipTypeSaveSuccessAction | IMembershipTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_MEMBERSHIPTYPES_SAVE)
            .mergeMap((action: IMembershipTypeSaveAction) => {
                return membershiptypesApi
                    .setMembershipType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.membershipType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createMembershipTypeEpic = (action$): Observable<IMembershipTypeCreateSuccessAction | IMembershipTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_MEMBERSHIPTYPES_CREATE)
            .mergeMap((_action: IMembershipTypeCreateAction) => {
                return membershiptypesApi
                    .createMembershipType()
                    .map(response =>
                        CreateSuccess(
                            response.membershipType,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateMembershipTypeEpic = (action$): Observable<IMembershipTypeValidateSuccessAction | IMembershipTypeValidateFailureAction> => {
        return action$
            .ofType(ACTION_MEMBERSHIPTYPES_VALIDATE)
            .mergeMap((action: IMembershipTypeValidateAction) => {
                return membershiptypesApi
                    .validateMembershipType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.membershipType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



